var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcArb24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#213147"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75894 7.72927V16.5741C2.75894 17.1387 3.06067 17.661 3.54946 17.9424L11.2093 22.3657C11.6981 22.6471 12.2999 22.6471 12.7887 22.3657L20.4485 17.9424C20.9373 17.661 21.239 17.1387 21.239 16.5741V7.72927C21.239 7.16459 20.9373 6.64236 20.4485 6.36094L12.7887 1.93763C12.2999 1.65621 11.6981 1.65621 11.2093 1.93763L3.54761 6.36094C3.05882 6.64236 2.75894 7.16459 2.75894 7.72927Z",
    fill: "#213147"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.67 13.8735L12.5776 16.8692C12.5481 16.9525 12.5481 17.0434 12.5776 17.1267L14.4569 22.2812L16.6305 21.0259L14.0216 13.8735C13.9623 13.7088 13.7291 13.7088 13.6698 13.8735H13.67Z",
    fill: "#12AAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8605 8.83447C15.8012 8.66976 15.568 8.66976 15.5087 8.83447L14.4163 11.8302C14.3867 11.9135 14.3867 12.0043 14.4163 12.0876L17.4952 20.5269L19.6689 19.2716L15.8603 8.83447H15.8605Z",
    fill: "#12AAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9982 2.27286C12.0519 2.27286 12.1056 2.28763 12.1536 2.31368L20.443 7.09985C20.5392 7.15543 20.5984 7.25902 20.5984 7.36834V16.9388C20.5984 17.05 20.5392 17.1517 20.443 17.2073L12.1536 21.9935C12.1073 22.0212 12.0519 22.0343 11.9982 22.0343C11.9444 22.0343 11.8907 22.0195 11.8427 21.9935L3.55334 17.211C3.45714 17.1554 3.39786 17.0518 3.39786 16.9425V7.37019C3.39786 7.25902 3.45714 7.15728 3.55334 7.10169L11.8427 2.31553C11.8909 2.28784 11.9444 2.27286 11.9982 2.27286ZM11.9982 0.875C11.7038 0.875 11.4074 0.950893 11.1428 1.10452L2.85533 5.88884C2.32572 6.19426 2 6.75915 2 7.36998V16.9405C2 17.5515 2.32593 18.1162 2.85533 18.4216L11.1447 23.2078C11.4095 23.3596 11.7038 23.4373 12 23.4373C12.2962 23.4373 12.5907 23.3614 12.8553 23.2078L21.1447 18.4216C21.6743 18.1162 22 17.5513 22 16.9405V7.36998C22 6.75895 21.6741 6.19426 21.1447 5.88884L12.8535 1.10452C12.5887 0.950893 12.2925 0.875 11.9982 0.875Z",
    fill: "#9DCCED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51584 20.5338L7.27866 18.4453L8.81354 19.7209L7.37855 21.0318L6.51584 20.5338Z",
    fill: "#213147"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3002 6.6875H9.19875C9.04142 6.6875 8.90071 6.78554 8.84697 6.93384L4.34222 19.2834L6.51583 20.5387L11.4761 6.93938C11.5225 6.81713 11.4316 6.6875 11.3002 6.6875Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9773 6.6875H12.8759C12.7185 6.6875 12.5778 6.78554 12.5241 6.93384L7.38062 21.0351L9.55423 22.2904L15.1533 6.93938C15.1978 6.81713 15.1069 6.6875 14.9773 6.6875Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArb24);
export default __webpack_public_path__ + "static/media/ic_arb_24.16344fe6cb8c2f5ee2b29651e1cdf9ef.svg";
export { ForwardRef as ReactComponent };